module.exports = __webpack_public_path__ + "img/logo.8784b59c.png";